/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
export type ExternalAdSignInParams = {
loginProvider: ExternalLoginProvider;
returnTo?: string;
};

export type GetRouteParams = {
path: string;
};

export type ListOffersParams = {
Page?: number;
PageSize?: number;
};

export type GetOrderByUniqueIdParams = {
uniqueId: string;
phoneNumber?: string;
};

export type GetGlobalListParams = {
SegmentId?: CustomerSegmentId;
};

export type LookupAccountsParams = {
SearchTerm?: string;
ExcludeAccountIds?: AccountId[];
PageNumber?: number;
PageSize?: number;
};

export type ListCustomerParams = {
SearchTerm?: string;
ExcludeCustomerIds?: AccountId[];
PageNumber?: number;
PageSize?: number;
SortDirection?: SortDirection;
};

export type SearchCustomerParams = {
SearchTerm?: string;
SortBy?: CustomerSearchSorting;
SortDirection?: SortDirection;
};

export type GetBrandsParams = {
Segment?: string;
};

export type UpdateLineDiscountParams = {
LegalEntity?: string;
Stock?: string;
ZipCode?: string;
IncoTerms?: IncoTerms;
DeliveryMethod?: DeliveryMethod;
};

export type RemoveFromBasketParams = {
LegalEntity?: string;
Stock?: string;
ZipCode?: string;
IncoTerms?: IncoTerms;
DeliveryMethod?: DeliveryMethod;
};

export type UpdateLineParams = {
LegalEntity?: string;
Stock?: string;
ZipCode?: string;
IncoTerms?: IncoTerms;
DeliveryMethod?: DeliveryMethod;
};

export type GetBasketParams = {
LegalEntity?: string;
Stock?: string;
ZipCode?: string;
IncoTerms?: IncoTerms;
DeliveryMethod?: DeliveryMethod;
};

export type ListApplicationRegistrationsWithoutFilterUnitParams = {
WithoutLocation?: boolean;
};

export type ListApplicationRegistrationsGroupedParams = {
Page?: number;
PageSize?: number;
};

export interface VideoMetaData {
  title: string;
  uniqueVideoId: string;
}

export interface VariantSelectorAttributeMetadata {
  /** @nullable */
  description?: string | null;
  displayName: string;
  systemName: string;
}

export interface VariantAttributeValueMetadata {
  systemName: string;
  value: string;
}

export interface UserProfileResponse {
  /** @nullable */
  addressOne?: string | null;
  /** @nullable */
  addressTwo?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  email: string;
  /** True when the user signed in via an OIDC provider configured with the PowerBI scope. */
  isPowerBiEnabled: boolean;
  name: string;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  zipCode?: string | null;
}

export interface UserInfoResponse {
  isImpersonating: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  userName?: string | null;
}

export type Url = string;

export interface UpdateSelectedOpportunityRequestModel {
  opportunityId?: OpportunityId;
}

export interface UpdateSelectedCustomerRequestModel {
  accountId: AccountId;
}

export interface UpdateProfileRequest {
  /** @nullable */
  addressOne?: string | null;
  /** @nullable */
  addressTwo?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country?: string | null;
  name: string;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  zipCode?: string | null;
}

export interface UpdateBasketLineRequest {
  quantity: number;
}

export interface UpdateBasketLineDiscountRequest {
  salesRepDiscount: number;
}

export interface UnauthorizedHttpResult {
  readonly statusCode: number;
}

export interface TranslationsWebsiteSparePartRegistrationsDeleteSparePart {
  failed: string;
  headline: string;
  teaser: string;
}

export interface TranslationsWebsiteSparePartRegistrations {
  addSparePart: string;
  articleNo: string;
  defaultDescription: string;
  deleteSparePart: TranslationsWebsiteSparePartRegistrationsDeleteSparePart;
  description: string;
  editSparePart: string;
  quantity: string;
  saleDate: string;
  save: string;
  saveFailed: string;
  saveSuccess: string;
}

export interface TranslationsWebsiteSharedSegmentations { [key: string]: unknown }

export interface TranslationsWebsiteSharedQuicksearch {
  articles: string;
  close: string;
  products: string;
  showAll: string;
  suggestions: string;
}

export interface TranslationsWebsiteSharedPagination {
  articles: string;
  nextPage: string;
  of: string;
  page: string;
  previousPage: string;
  products: string;
  showNext: string;
  showNextArticles: string;
  showPrevious: string;
  showPreviousArticles: string;
  youHaveViewed: string;
}

export interface TranslationsWebsiteSharedNavigation {
  breadcrumbs: string;
  category: string;
  corporateLink: string;
  footer: string;
  nav: string;
  primary: string;
  product: string;
  secondary: string;
  segmentBarTitle: string;
  slider: string;
  top: string;
  user: string;
}

export interface TranslationsWebsiteSharedFilters {
  allFilters: string;
  resetFilters: string;
  showSelected: string;
}

export interface TranslationsWebsiteSharedCustomerInfo {
  address1: string;
  address2: string;
  city: string;
  country: string;
  email: string;
  name: string;
  newPassword: string;
  oldPassword: string;
  password: string;
  phone: string;
  repeatPassword: string;
  zipcode: string;
}

export interface TranslationsWebsiteShared {
  account: string;
  articleNo: string;
  back: string;
  backTo: string;
  becomes: string;
  cancel: string;
  close: string;
  continue: string;
  customer: string;
  customerInfo: TranslationsWebsiteSharedCustomerInfo;
  delete: string;
  edit: string;
  falseString: string;
  filters: TranslationsWebsiteSharedFilters;
  frontpage: string;
  genericErrorMsg: string;
  itemNo: string;
  loading: string;
  menuLabel: string;
  miniBasketTitle: string;
  moreInformationAbout: string;
  navigation: TranslationsWebsiteSharedNavigation;
  next: string;
  nextAdditionals: string;
  nextConfiguration: string;
  noPrice: string;
  noProductsFound: string;
  noResult: string;
  onSale: string;
  pagination: TranslationsWebsiteSharedPagination;
  previous: string;
  priceError: string;
  quicksearch: TranslationsWebsiteSharedQuicksearch;
  readMore: string;
  reset: string;
  save: string;
  searchIconLabel: string;
  searchInputLabel: string;
  searchPlaceholder: string;
  searchSubmit: string;
  segmentations: TranslationsWebsiteSharedSegmentations;
  showLess: string;
  showMore: string;
  siteName: string;
  skipToMainContent: string;
  slide: string;
  trueString: string;
  unsupportedVideo: string;
  yesContinueBtn: string;
}

export interface TranslationsWebsiteRegistrationComposites {
  registrationCompositeAlreadyOnAccount: string;
  registrationCompositeDoesNotExist: string;
  registrationCompositeLocationExists: string;
  sourceRegistrationCompositeHasNoLocation: string;
  targetAccountDoesNotExist: string;
  targetAccountRequired: string;
  targetRegistrationCompositeRequired: string;
}

export interface TranslationsWebsiteProductListSorting {
  nameAscending: string;
  nameDescending: string;
  priceAscending: string;
  priceDescending: string;
  relevance: string;
  sortingStr: string;
}

export interface TranslationsWebsiteProductListSelector {
  button: string;
  description: string;
  title: string;
}

export interface TranslationsWebsiteProductListPageMetaData {
  description: string;
  keywords: string;
  title: string;
}

export interface TranslationsWebsiteProductListFilters {
  brand: string;
  campaign: string;
  choose: string;
  filtersButton: string;
  inCampaign: string;
  max: string;
  min: string;
  outlet: string;
  price: string;
  productGroup: string;
  resetFilters: string;
  seeAll: string;
  showProductsBtnString1: string;
  showProductsBtnString2: string;
  stockFilter: string;
  subPages: string;
}

export interface TranslationsWebsiteProductListAvailability {
  available: string;
  externalWarehouse: string;
  inStoreOnly: string;
  onlyFew: string;
  soldOut: string;
  soldOutOnWeb: string;
  unknown: string;
}

export interface TranslationsWebsiteProductList {
  availability: TranslationsWebsiteProductListAvailability;
  borderStyleFilterTranslation: string;
  didYouMean: string;
  filters: TranslationsWebsiteProductListFilters;
  fromText: string;
  noProductsSelected: string;
  noResultsFor: string;
  pageMetaData: TranslationsWebsiteProductListPageMetaData;
  productListTitle: string;
  products: string;
  refineSelection: string;
  resultsFor: string;
  resultsFound: string;
  searchIn: string;
  searchInResults: string;
  searchInResultsPlaceholder: string;
  searchSuggestionsHeadline: string;
  searchSuggestionsText1: string;
  searchSuggestionsText2: string;
  searchSuggestionsText3: string;
  selector: TranslationsWebsiteProductListSelector;
  showAll: string;
  showAllSizes: string;
  showing: string;
  showLess: string;
  showMoreProductsButtonMore: string;
  showMoreProductsButtonShow: string;
  showPagination: string;
  sortBy: string;
  sorting: TranslationsWebsiteProductListSorting;
  view: string;
}

export interface TranslationsWebsiteProductDetails {
  accessoryProducts: string;
  addedToBasket: string;
  addOn: string;
  addToBasket: string;
  clearSelection: string;
  documents: string;
  inserts: string;
  insertsProducts: string;
  mandatoryAddOns: string;
  price: string;
  productDescription: string;
  relatedProducts: string;
  siblingsTitle: string;
  sparePartsProducts: string;
  specifications: string;
  variantsTitle: string;
}

export interface TranslationsWebsitePowerBiReport {
  loadError: string;
  loadingReport: string;
  noAccessError: string;
  sessionExpiredError: string;
  signInAgain: string;
  tryAgain: string;
}

export interface TranslationsWebsitePageTitles {
  articleList: string;
  basket: string;
  confirmEmail: string;
  forgottenPassword: string;
  login: string;
  profile: string;
  register: string;
  resetPassword: string;
  settings: string;
}

export interface TranslationsWebsiteOrderSummary {
  discount: string;
  shipping: string;
  subtotal: string;
  title: string;
  totalPrice: string;
  vat: string;
}

export interface TranslationsWebsiteOrderConfirmation {
  backButton: string;
  heading: string;
  headingAuthNeeded: string;
  orderMissing: string;
  orderNr: string;
  phoneNrDoesNotMatch: string;
  submitAuthNeeded: string;
  text: string;
  textAuthNeeded: string;
}

export interface TranslationsWebsiteOrderPageMetaData {
  description: string;
  keywords: string;
  title: string;
}

export interface TranslationsWebsiteOrder {
  addressRequired: string;
  basketMissing: string;
  billingAddressRequired: string;
  billingAddressTitle: string;
  cityRequired: string;
  comment: string;
  commentTooLong: string;
  createOrderFailed: string;
  customerInfoTitle: string;
  customerReferenceRequired: string;
  deliveryMethodRequired: string;
  deliveryTermsRequired: string;
  desiredDeliveryDateRequired: string;
  emailInvalid: string;
  emailRequired: string;
  legalEntityRequired: string;
  missingStock: string;
  nameRequired: string;
  orderSummaryTitle: string;
  pageMetaData: TranslationsWebsiteOrderPageMetaData;
  paymentTitle: string;
  phoneNumberRequired: string;
  shippingAddressTitle: string;
  shippingTitle: string;
  stockRequired: string;
  validationError: string;
  zipCodeRequired: string;
}

export interface TranslationsWebsiteOpportunity {
  city: string;
  contactPerson: string;
  customerReference: string;
  date: string;
  deliveryAddress: string;
  deliveryMethod: string;
  desiredDelivery: string;
  incoTerms: string;
  internalContact: string;
  legalEntity: string;
  ourSalesPerson: string;
  paymentTerms: string;
  quotationExpirationDate: string;
  quoteType: string;
  salesAndDeliveryTerms: string;
  stock: string;
  zipcode: string;
}

export interface TranslationsWebsiteOpportunitiesConfirmation {
  headline: string;
  text: string;
}

export interface TranslationsWebsiteOpportunities {
  confirmation: TranslationsWebsiteOpportunitiesConfirmation;
  opportunityID: string;
  saveFailed: string;
  selectOpportunity: string;
}

export interface TranslationsWebsiteOfferOverwriteBasket {
  headline: string;
  teaser: string;
}

export interface TranslationsWebsiteOfferOfferStatus {
  approved: string;
  awaitingApproval: string;
  draft: string;
}

export interface TranslationsWebsiteOfferDeleteOfferModal {
  failed: string;
  headline: string;
  teaser: string;
}

export interface TranslationsWebsiteOffer {
  deleteOffer: string;
  deleteOfferModal: TranslationsWebsiteOfferDeleteOfferModal;
  downloadOffer: string;
  editOffer: string;
  historyHeadline: string;
  name: string;
  offerDate: string;
  offerNo: string;
  offerStatus: TranslationsWebsiteOfferOfferStatus;
  overwriteBasket: TranslationsWebsiteOfferOverwriteBasket;
  status: string;
}

export interface TranslationsWebsiteMobileMenu {
  goToPage: string;
  menuHeadingPrefix: string;
  showAll: string;
  showAllIn: string;
  showCategoriesIn: string;
}

export interface TranslationsWebsiteMiniBasket {
  goToBasket: string;
  productsInCart: string;
}

export interface TranslationsWebsiteLocationsPageMetaData {
  description: string;
  title: string;
}

export interface TranslationsWebsiteLocations {
  address: string;
  applications: string;
  charterer: string;
  chartererLengthExceeded: string;
  deleteHeadline: string;
  deleteMessage: string;
  deleteSuccess: string;
  description: string;
  editLocation: string;
  filterUnits: string;
  id: string;
  identifier: string;
  identifierLengthExceeded: string;
  iMOnumber: string;
  latitude: string;
  latitudeLengthExceeded: string;
  latitudeRequired: string;
  link: string;
  locationDetails: string;
  locationName: string;
  locationWithIdentifierExists: string;
  longitude: string;
  longitudeLengthExceeded: string;
  longitudeRequired: string;
  notFound: string;
  number: string;
  operatorLengthExceeded: string;
  operatorRequired: string;
  ownerLengthExceeded: string;
  ownerOperator: string;
  ownerRequired: string;
  pageMetaData: TranslationsWebsiteLocationsPageMetaData;
  register: string;
  saveSuccess: string;
  shipOwner: string;
  shipyard: string;
  site: string;
  technicalManager: string;
  title: string;
  type: string;
  vessel: string;
  vesselType: string;
  vesselTypeLengthExceeded: string;
  vesselTypeRequired: string;
}

export interface TranslationsWebsiteKnowledgeHub {
  allArticles: string;
  filterByCategory: string;
  noArticles: string;
  readArticle: string;
  readArticleAriaLabel: string;
  relatedTags: string;
}

export interface TranslationsWebsiteFooter {
  copyright: string;
}

export interface TranslationsWebsiteFilterRegistrationsDeleteFilterRegistrations {
  failed: string;
  headline: string;
  success: string;
  teaser: string;
}

export interface TranslationsWebsiteFilterRegistrations {
  addFilterUnit: string;
  articleNo: string;
  batchNo: string;
  dateOfSale: string;
  defaultFilterInsertName: string;
  defaultUnitName: string;
  delete: string;
  deleteFailed: string;
  deleteFilterRegistrations: TranslationsWebsiteFilterRegistrationsDeleteFilterRegistrations;
  deleteSuccess: string;
  edit: string;
  editFilterUnit: string;
  filterId: string;
  filterInsertHeadline: string;
  filterUnitInApplicationAlreadyExists: string;
  goToSelectionByApplication: string;
  insertName: string;
  insertType: string;
  installationDate: string;
  itemNumber: string;
  lastChangedDate: string;
  name: string;
  noItemFound: string;
  orderNo: string;
  quantity: string;
  save: string;
  saveFailed: string;
  saveSuccess: string;
}

export interface TranslationsWebsiteFilterGroup {
  accountInformation: string;
  application: string;
  installedEquipment: string;
}

export interface TranslationsWebsiteEmail { [key: string]: unknown }

export interface TranslationsWebsiteCustomersPageMetaData {
  description: string;
  title: string;
}

export interface TranslationsWebsiteCustomersMap {
  mapErrorMessage: string;
}

export interface TranslationsWebsiteCustomersFilters {
  applicationBrand: string;
  applicationFluidType: string;
  applicationModel: string;
  applications: string;
  applicationType: string;
  customerCity: string;
  customerCountry: string;
  customerGroup: string;
  customerKeyAccountManager: string;
  customerOwner: string;
  customerSegment: string;
  customerSubSegment: string;
  customerType: string;
  fluidtype: string;
  industry: string;
  marineoffshore: string;
  mining: string;
  power: string;
  wind: string;
}

export interface TranslationsWebsiteCustomers {
  accountName: string;
  accountNo: string;
  customerGroup: string;
  customerNumber: string;
  customerSegment: string;
  customerSubSegment: string;
  customerType: string;
  filters: TranslationsWebsiteCustomersFilters;
  groupCoName: string;
  headerLinkLabel: string;
  internalName: string;
  keyAccountManager: string;
  map: TranslationsWebsiteCustomersMap;
  nameLine2: string;
  owner: string;
  pageMetaData: TranslationsWebsiteCustomersPageMetaData;
  pageNumberOutOfRange: string;
  pageSizeOutOfRange: string;
  title: string;
}

export interface TranslationsWebsiteCustomerSelector {
  changeCustomer: string;
  chooseCustomer: string;
  customerNotValid: string;
  searchPlaceholder: string;
}

export interface TranslationsWebsiteCustomerPageMetaData {
  description: string;
  title: string;
}

export interface TranslationsWebsiteCustomer {
  accountNo: string;
  city: string;
  country: string;
  group: string;
  groupCoName: string;
  internalName: string;
  keyAccountManager: string;
  name: string;
  nameLine2: string;
  owner: string;
  pageMetaData: TranslationsWebsiteCustomerPageMetaData;
  segment: string;
  status: string;
  subSegment: string;
  thirdPartyResponsible: string;
  type: string;
}

export interface TranslationsWebsiteCompositeMoveComposite {
  button: string;
  compositeMoved: string;
  compositeMoveFailed: string;
  confirmButton: string;
  filterUnitAndLocationMoved: string;
  filterUnitAndLocationMoveFailed: string;
  filterUnitMoved: string;
  filterUnitMoveFailed: string;
  headline: string;
  moveCompositeOption: string;
  moveFilterUnitOption: string;
  moveFilterUnitWithLocationOption: string;
  noAccountsFound: string;
  noApplicationsAvailable: string;
  noApplicationsWithoutLocationAvailable: string;
  searchAccounts: string;
  selectApplication: string;
  teaser: string;
}

export interface TranslationsWebsiteCompositeDeleteComposite {
  button: string;
  failed: string;
  headline: string;
  success: string;
  teaser: string;
}

export interface TranslationsWebsiteComposite {
  deleteComposite: TranslationsWebsiteCompositeDeleteComposite;
  moveComposite: TranslationsWebsiteCompositeMoveComposite;
}

export interface TranslationsWebsiteBasketPageMetaData {
  description: string;
  keywords: string;
  title: string;
}

export interface TranslationsWebsiteBasketOverwriteOffer {
  headline: string;
  teaser: string;
}

export interface TranslationsWebsiteBasketDeleteBasketProducts {
  headline: string;
  teaser: string;
}

export interface TranslationsWebsiteBasketBasketNotificationModal {
  title: string;
}

export interface TranslationsWebsiteBasket {
  additionalProducts: string;
  addOneItem: string;
  amount: string;
  basketEmpty: string;
  basketEmptyMessage: string;
  basketName: string;
  basketNotificationModal: TranslationsWebsiteBasketBasketNotificationModal;
  checkoutButton: string;
  companionAdditionalLineCannotBeCompanion: string;
  companionProductNotAllowedAsAdditionalLine: string;
  companionVariantIdRequired: string;
  continueShoppingButton: string;
  createNewOffer: string;
  createOffer: string;
  customerDiscount: string;
  customerRef: string;
  deleteBasketProducts: TranslationsWebsiteBasketDeleteBasketProducts;
  editBasketName: string;
  emptyBasketHeading: string;
  emptyBasketText: string;
  goToOpportunity: string;
  invalidCompanionProduct: string;
  mandatory: string;
  overwriteOffer: TranslationsWebsiteBasketOverwriteOffer;
  pageMetaData: TranslationsWebsiteBasketPageMetaData;
  price: string;
  quantityIncrement: string;
  quantityTitle: string;
  removeLine: string;
  removeOffer: string;
  removeOfferFailed: string;
  removeOfferSuccess: string;
  removeOneItem: string;
  salesRepDiscount: string;
  salesRepDiscountLabel: string;
  saveAsDraft: string;
  saveBasketName: string;
  saveOffer: string;
  title: string;
  total: string;
}

export interface TranslationsWebsiteAuthor {
  contact: string;
  contactAriaLabel: string;
  linkedIn: string;
  linkedInAriaLabel: string;
}

export interface TranslationsWebsiteAuthSignin {
  azureAdLogin: string;
  forgotPassword: string;
  heading: string;
  login: string;
  logout: string;
  newCustomer: string;
  register: string;
  rememberMe: string;
  teaser: string;
  unknownUserOrInvalidPassword: string;
}

export interface TranslationsWebsiteAuthSetPassword {
  failed: string;
  heading: string;
  submit: string;
  success: string;
}

export interface TranslationsWebsiteAuthResetPassword {
  heading: string;
  submit: string;
  success: string;
}

export interface TranslationsWebsiteAuthRegister {
  confirmPasswordIsRequired: string;
  emailIsNotValid: string;
  emailIsRequired: string;
  heading: string;
  passwordIsRequired: string;
  passwordMaxLength: string;
  passwordMinLength: string;
  passwordsAreNotTheSame: string;
  submit: string;
  success: string;
  terms: string;
  termsText: string;
}

export interface TranslationsWebsiteAuthForgotPassword {
  heading: string;
  submit: string;
  success: string;
  text: string;
}

export interface TranslationsWebsiteAuthConfirmEmail {
  failed: string;
  heading: string;
  success: string;
}

export interface TranslationsWebsiteAuthChangePassword {
  confirmPasswordIsRequired: string;
  failed: string;
  newPasswordIsRequired: string;
  newPasswordMaxLength: string;
  newPasswordMinLength: string;
  oldPasswordIsRequired: string;
  passwordsAreNotTheSame: string;
}

export interface TranslationsWebsiteAuth {
  backToSignIn: string;
  changePassword: TranslationsWebsiteAuthChangePassword;
  confirmEmail: TranslationsWebsiteAuthConfirmEmail;
  forgotPassword: TranslationsWebsiteAuthForgotPassword;
  impersonating: string;
  register: TranslationsWebsiteAuthRegister;
  resetPassword: TranslationsWebsiteAuthResetPassword;
  setPassword: TranslationsWebsiteAuthSetPassword;
  signin: TranslationsWebsiteAuthSignin;
}

export interface TranslationsWebsiteApplicationsSwitchCustomer {
  failed: string;
  headline: string;
  teaser: string;
  yesContinueBtn: string;
}

export interface TranslationsWebsiteApplicationsPageMetaData {
  description: string;
  title: string;
}

export interface TranslationsWebsiteApplicationsDeleteApplicationRegistrations {
  failed: string;
  headline: string;
  success: string;
  teaser: string;
}

export interface TranslationsWebsiteApplications {
  addComment: string;
  additionalInformation: string;
  ambientTemperature: string;
  application: string;
  applicationInformation: string;
  applicationListHeadline: string;
  brand: string;
  chooseOrAddGroup: string;
  comments: string;
  deleteApplicationRegistrations: TranslationsWebsiteApplicationsDeleteApplicationRegistrations;
  deleteFailed: string;
  deleteSuccess: string;
  diesel: string;
  editApplication: string;
  filterUnitHeadline: string;
  filterVolume: string;
  fluidBrand: string;
  fluidType: string;
  goToSelectionByApp: string;
  group: string;
  groupInfo: string;
  max: string;
  maxAmbientTemperature: string;
  maxError: string;
  maxOperationTemperature: string;
  min: string;
  minAmbientTemperature: string;
  minError: string;
  minOperationTemperature: string;
  model: string;
  name: string;
  nameOfApplication: string;
  normal: string;
  normalOperationTemperature: string;
  normError: string;
  oil: string;
  oilSystem: string;
  oilSystemBrand: string;
  operationTemperature: string;
  other: string;
  pageMetaData: TranslationsWebsiteApplicationsPageMetaData;
  powerSupply: string;
  registerApplication: string;
  registerComposite: string;
  saveComment: string;
  saveCommentFailed: string;
  saveCommentSuccess: string;
  seeDetails: string;
  segment: string;
  sparePartHeadline: string;
  switchCustomer: TranslationsWebsiteApplicationsSwitchCustomer;
  systemVolume: string;
  temperatureUnit: string;
  title: string;
  viscosity: string;
  viscosityUnit: string;
  volumeUnit: string;
}

export interface TranslationsWebsiteApplicationSummary {
  addedToOfferError: string;
  addedToOfferSuccess: string;
  additionals: string;
  addon: string;
  addToOffer: string;
  application: string;
  backToSelector: string;
  contactPerson: string;
  filterInserts: string;
  filterSpecification: string;
  filterUnit: string;
  includedInPrice: string;
  mobile: string;
  segment: string;
  segmentSpecification: string;
  segmentSpecifications: string;
  subApplication: string;
  unitConfiguration: string;
}

export interface TranslationsWebsiteApplicationRegistrations {
  chooseApplication: string;
  chooseSegment: string;
  chooseSegmentFirst: string;
  save: string;
  saveFailed: string;
  saveSuccess: string;
}

export interface TranslationsWebsiteAppBuilderSolutionServices {
  conditionsMonitoring: string;
  installation: string;
  maintenance: string;
  oilFuelAnalysis: string;
  projectBasedServices: string;
  rental: string;
}

export interface TranslationsWebsiteAppBuilderSolutionMetaDataDescription {
  application: string;
  applicationSpecifications: string;
  configuration: string;
  filterUnit: string;
  segment: string;
  service: string;
  summary: string;
}

export interface TranslationsWebsiteAppBuilderSolution {
  application: string;
  configuration: string;
  description: string;
  filterUnit: string;
  metaDataDescription: TranslationsWebsiteAppBuilderSolutionMetaDataDescription;
  noSecondary: string;
  option: string;
  primary: string;
  progressAdditional: string;
  progressApplication: string;
  progressConfiguration: string;
  progressFilterUnit: string;
  progressSegment: string;
  progressService: string;
  progressSpecifications: string;
  progressSubApplication: string;
  progressSummary: string;
  secondary: string;
  segment: string;
  service: string;
  serviceMessage: string;
  services: TranslationsWebsiteAppBuilderSolutionServices;
  specifications: string;
  subApplication: string;
  summary: string;
  title: string;
}

export interface TranslationsWebsiteAccountSettings {
  changePassword: string;
  heading: string;
  submit: string;
}

export interface TranslationsWebsiteAccountProfile {
  deleteProfileText: string;
  deleteProfileTitle: string;
  heading: string;
  nameIsRequired: string;
  submit: string;
  supportMail: string;
}

export interface TranslationsWebsiteAccount {
  profile: TranslationsWebsiteAccountProfile;
  settings: TranslationsWebsiteAccountSettings;
  welcome: string;
}

export interface TranslationsWebsite {
  account: TranslationsWebsiteAccount;
  appBuilderSolution: TranslationsWebsiteAppBuilderSolution;
  applicationRegistrations: TranslationsWebsiteApplicationRegistrations;
  applications: TranslationsWebsiteApplications;
  applicationSummary: TranslationsWebsiteApplicationSummary;
  auth: TranslationsWebsiteAuth;
  author: TranslationsWebsiteAuthor;
  basket: TranslationsWebsiteBasket;
  composite: TranslationsWebsiteComposite;
  customer: TranslationsWebsiteCustomer;
  customers: TranslationsWebsiteCustomers;
  customerSelector: TranslationsWebsiteCustomerSelector;
  email: TranslationsWebsiteEmail;
  filterGroup: TranslationsWebsiteFilterGroup;
  filterRegistrations: TranslationsWebsiteFilterRegistrations;
  footer: TranslationsWebsiteFooter;
  knowledgeHub: TranslationsWebsiteKnowledgeHub;
  locations: TranslationsWebsiteLocations;
  miniBasket: TranslationsWebsiteMiniBasket;
  mobileMenu: TranslationsWebsiteMobileMenu;
  offer: TranslationsWebsiteOffer;
  opportunities: TranslationsWebsiteOpportunities;
  opportunity: TranslationsWebsiteOpportunity;
  order: TranslationsWebsiteOrder;
  orderConfirmation: TranslationsWebsiteOrderConfirmation;
  orderSummary: TranslationsWebsiteOrderSummary;
  pageTitles: TranslationsWebsitePageTitles;
  powerBiReport: TranslationsWebsitePowerBiReport;
  productDetails: TranslationsWebsiteProductDetails;
  productList: TranslationsWebsiteProductList;
  registrationComposites: TranslationsWebsiteRegistrationComposites;
  shared: TranslationsWebsiteShared;
  sparePartRegistrations: TranslationsWebsiteSparePartRegistrations;
}

export enum StockStatus {
  InStock= 'InStock',
  FewInStock= 'FewInStock',
  OutOfStock= 'OutOfStock',

}
export interface StaticLinkModel {
  pageType: PageType;
  url: RelativeUrl;
}

export type SpecsMetaDataSpecs = {[key: string]: string};

export interface SpecsMetaData {
  specs: SpecsMetaDataSpecs;
}

export interface SparePartRegistrationRequest {
  /** @nullable */
  articleNumber?: string | null;
  /** @nullable */
  quantity?: number | null;
  /** @nullable */
  saleDate?: string | null;
}

export type SparePartRegistrationId = number;

export interface SparePartRegistrationResponse {
  /** @nullable */
  articleNumber?: string | null;
  id: SparePartRegistrationId;
  /** @nullable */
  quantity?: number | null;
  /** @nullable */
  saleDate?: string | null;
}

export interface SparePartRegistration {
  /** @nullable */
  articleNumber?: string | null;
  filterUnitRegistrationId: FilterUnitRegistrationId;
  id: SparePartRegistrationId;
  /** @nullable */
  quantity?: number | null;
  /** @nullable */
  saleDate?: string | null;
}

export enum SortDirection {
  Ascending= 'Ascending',
  Descending= 'Descending',

}
export interface SkuMediaItemMetaData {
  /** @nullable */
  metadata?: string | null;
  type: string;
  /** @nullable */
  url?: string | null;
}

export interface SkuMediaMetaData {
  files: SkuMediaItemMetaData[];
  images: SkuMediaItemMetaData[];
  videos: SkuMediaItemMetaData[];
}

export interface SkuAttributesMetaData {
  /** @nullable */
  accessories?: IncludedItemMetaData[] | null;
  /** @nullable */
  associatedProducts?: AssociatedProductReference[] | null;
  brand: string;
  disableAddToBasket: boolean;
  /** @nullable */
  inserts?: IncludedItemMetaData[] | null;
  longDescription: string;
  /** @nullable */
  mandatoryAddOns?: IncludedItemMetaData[] | null;
  media?: SkuMediaMetaData;
  metaDescription: string;
  metaKeywords: string;
  metaTitle: string;
  shortDescription: string;
  size: string;
  /** @nullable */
  spareParts?: IncludedItemMetaData[] | null;
  splashText: string[];
  stockStatus: StockStatus;
  variantAttributes: VariantAttributeValueMetadata[];
}

export interface SimpleImageResponse {
  /** @nullable */
  altText?: string | null;
  /** @nullable */
  height?: number | null;
  url: AbsoluteUrl;
  /** @nullable */
  width?: number | null;
}

export interface SignInRequest {
  email: string;
  password: string;
  rememberMe: boolean;
}

export interface SiblingMetaData {
  id: string;
  /** @nullable */
  imageMetaData?: string | null;
  name: string;
  /** @nullable */
  url?: string | null;
}

export interface SettingsResponse {
  cmsSettings: CmsSettingsResponse;
  cultureCode: string;
  currencySettings: CurrencySettingsResponse;
  device: BrowserDeviceType;
  /** @nullable */
  googleMapsApiKey?: string | null;
  isSalesPortal: boolean;
  searchSettings: SearchSettingsResponse;
  segmentations: SegmentationResponse[];
  user?: UserInfoResponse;
}

export interface SelectedOpportunityResponse {
  /** @nullable */
  readonly customerAccountId?: string | null;
  /** @nullable */
  readonly externalOwnerId?: string | null;
  id: OpportunityId;
  readonly name: string;
}

export interface SelectedAccountResponse {
  /** @nullable */
  customerNumber?: string | null;
  id: AccountId;
  name: string;
  /** @nullable */
  owner?: string | null;
}

export interface SelectedAccountConflict { [key: string]: unknown }

export interface SegmentationResponse {
  baseUrl: string;
  cultureCode: string;
  isCurrentSegmentation: boolean;
  name: string;
  primaryPath: string;
  url: string;
}

export type SegmentationId = number;

export interface SearchSettingsResponse {
  applicationSolutionBuilderScopeId: string;
  bandsScopeId: string;
  browseScopeId: string;
  categoryIdsFilterId: string;
  categoryNamesFilterId: string;
  contentSearchScopeId: string;
  detailsScopeId: string;
  fullSearchScopeId: string;
  installedEquipmentScopeId: string;
  priceFilterId: string;
  productCategoryRootSystemName: string;
  quickSearchScopeId: string;
  searchableIdsFilterId: string;
  searchApiHost: string;
  searchSegment: string;
  searchToken: string;
}

export interface RouteResponse {
  /** @nullable */
  content?: string | null;
  model?: CmsModel;
  route?: ResourceLocation;
  segmentationId: SegmentationId;
}

export interface ResetPasswordRequest {
  code: string;
  confirmPassword: string;
  password: string;
  userId: string;
}

export type RelativeUrl = string;

export type RegistrationCompositeId = number;

export interface RegistrationCompositeDetailsResponse {
  /** @nullable */
  additionalInformation?: string | null;
  /** @nullable */
  applicationName?: string | null;
  /** @nullable */
  applicationSystemName?: string | null;
  /** @nullable */
  brand?: string | null;
  comments: ApplicationRegistrationCommentResponse[];
  filterUnit?: FilterUnitRegistration;
  filterUnitId?: FilterUnitRegistrationId;
  /** @nullable */
  fluidBrand?: string | null;
  /** @nullable */
  fluidType?: string | null;
  /** @nullable */
  group?: string | null;
  id?: ApplicationRegistrationId;
  location?: LocationDetailsResponse;
  /** @nullable */
  maxAmbientTemperature?: number | null;
  /** @nullable */
  maxOperationTemperature?: number | null;
  /** @nullable */
  minAmbientTemperature?: number | null;
  /** @nullable */
  minOperationTemperature?: number | null;
  /** @nullable */
  model?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  normalOperationTemperature?: number | null;
  /** @nullable */
  oilSystem?: string | null;
  /** @nullable */
  oilSystemBrand?: string | null;
  /** @nullable */
  powerSupply?: string | null;
  /** @nullable */
  segmentName?: string | null;
  /** @nullable */
  segmentSystemName?: string | null;
  /** @nullable */
  systemVolume?: number | null;
  /** @nullable */
  viscosity?: number | null;
}

export enum QuoteType {
  Primary= 'Primary',
  Alternative= 'Alternative',

}
export type ProductVariantId = string;

export type ProductNumber = string;

export type ProductMasterId = string;

export interface ResourceLocation {
  area: Area;
  externalRoute: RelativeUrl;
  pageType?: PageType;
  productCategoryId?: ProductCategoryId;
  productMasterId?: ProductMasterId;
}

export interface PurchaseLineResponse {
  customerDiscount: number;
  id: number;
  image: ImageResponse;
  lineType: LineType;
  listPrice: number;
  name: string;
  /** @nullable */
  parentBasketLineId?: number | null;
  price: number;
  productMasterId?: ProductMasterId;
  productNumber: ProductNumber;
  productVariantId: ProductVariantId;
  quantity: number;
  salesRepDiscount: number;
  /** @nullable */
  url?: string | null;
}

export interface PurchaseApplicationLineResponse {
  additionalBasketLines: PurchaseLineResponse[];
  categories: string[];
  customerDiscount: number;
  id: number;
  image: ImageResponse;
  lineType: LineType;
  listPrice: number;
  name: string;
  price: number;
  productMasterId?: ProductMasterId;
  productNumber: ProductNumber;
  productVariantId: ProductVariantId;
  quantity: number;
  salesRepDiscount: number;
  /** @nullable */
  url?: string | null;
}

export type ProductCategoryId = string;

export interface ProductCategoryResponse {
  breadcrumbs: BreadCrumbModel[];
  description: string;
  id: ProductCategoryId;
  metaDescription: string;
  metaKeywords: string;
  metaTitle: string;
  name: string;
  showLinkToSelector: boolean;
  url: string;
}

export interface ProductAttributesMetaData {
  brand: string;
  metaDescription: string;
  metaKeywords: string;
  metaTitle: string;
  splashText: string[];
  stockStatus: StockStatus;
  /** @nullable */
  url?: string | null;
  variantSelectors: VariantSelectorAttributeMetadata[];
}

export interface ProblemDetails {
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export interface ProblemHttpResult {
  readonly contentType: string;
  problemDetails: ProblemDetails;
  readonly statusCode: number;
}

export interface PriceResponse {
  price: number;
  productNumber: ProductNumber;
}

export interface PriceRequest {
  lines: ProductNumber[];
  skipCache: boolean;
}

export interface PowerBiEmbedResponse {
  accessToken: string;
  accountFilterColumn: string;
  accountFilterTable: string;
  reportId: string;
  reportSection: string;
  workspaceId: string;
}

export interface PatchBasketRequest {
  /** @nullable */
  name?: string | null;
}

export enum PageType {
  Basket= 'Basket',
  OrderConfirmation= 'OrderConfirmation',
  Search= 'Search',
  UserSignIn= 'UserSignIn',
  UserRegister= 'UserRegister',
  UserLoginConfirmEmail= 'UserLoginConfirmEmail',
  UserConfirmEmailSetPassword= 'UserConfirmEmailSetPassword',
  UserForgotPassword= 'UserForgotPassword',
  UserResetPassword= 'UserResetPassword',
  InternalError= 'InternalError',
  NotFound= 'NotFound',
  UserProfile= 'UserProfile',
  UserSettings= 'UserSettings',
  LoginCallback= 'LoginCallback',
  AppSolutionBuilder= 'AppSolutionBuilder',
  CustomersList= 'CustomersList',
  Customer= 'Customer',
  ApplicationDetail= 'ApplicationDetail',
  LocationDetail= 'LocationDetail',
  EditLocation= 'EditLocation',
  Opportunity= 'Opportunity',
  CustomerExternalIdentifier= 'CustomerExternalIdentifier',
  RegistrationComposite= 'RegistrationComposite',

}
export enum OrderStatus {
  Draft= 'Draft',
  AwaitingApproval= 'AwaitingApproval',
  Approved= 'Approved',

}
export type OrderId = number;

export interface OrderAddressResponse {
  addressOne: string;
  /** @nullable */
  addressTwo?: string | null;
  city: string;
  /** @nullable */
  country?: string | null;
  name: string;
  zipCode: string;
}

export interface OrderDetailResponse {
  applicationLines: PurchaseApplicationLineResponse[];
  billingAddress: OrderAddressResponse;
  /** @nullable */
  comment?: string | null;
  currency: string;
  customerReference: string;
  date: string;
  deliveryAddress: OrderAddressResponse;
  deliveryMethod: DeliveryMethod;
  deliveryTerms: IncoTerms;
  desiredDeliveryDate: string;
  dutyCharges: number;
  email: EmailAddress;
  expirationDate: string;
  freightTotal: number;
  id: OrderId;
  insuranceAmount: number;
  internalContact: string;
  lines: PurchaseLineResponse[];
  /** @nullable */
  name?: string | null;
  ourSalesperson: string;
  paymentTerms: string;
  /** @nullable */
  phoneNumber?: string | null;
  quoteType: QuoteType;
  salesAndDeliveryTerms: string;
  status: OrderStatus;
  totalInclVat: number;
  totalOutlayShippingCharges: number;
  totalVat: number;
  yourContact: string;
}

export type OpportunityId = string;

export interface OpportunityDetails {
  customerAccountId: string;
  /** @nullable */
  externalOwnerId?: string | null;
  id: OpportunityId;
  name: string;
  /** @nullable */
  stepName?: string | null;
}

export interface OpportunityListResponse {
  opportunities: OpportunityDetails[];
}

export interface OfferResponse {
  createdTime: string;
  id: OrderId;
  /** @nullable */
  name?: string | null;
  status: OrderStatus;
}

export interface OffersResponse {
  offers: OfferResponse[];
  totalHits: number;
}

export interface MoveRegistrationCompositeRequest {
  targetAccountId: AccountId;
}

export interface MoveFilterUnitRequest {
  moveLocation: boolean;
  targetRegistrationCompositeId: RegistrationCompositeId;
}

export interface MegaMenuItem {
  children: MegaMenuItem[];
  name: string;
  route: ResourceLocation;
  showLinkToSelector: boolean;
}

export interface MegaMenuModel {
  items: MegaMenuItem[];
}

export interface MediaMetaData {
  /** @nullable */
  altText?: string | null;
  /** @nullable */
  fileName?: string | null;
  /** @nullable */
  types?: MediaTypeMetaData[] | null;
}

export enum MediaBankFileInfoType {
  OriginalFile= 'OriginalFile',
  Size72= 'Size72',
  Size180= 'Size180',
  Size320= 'Size320',
  Size480= 'Size480',
  Size720= 'Size720',
  Size960= 'Size960',
  Size1280= 'Size1280',
  Size1920= 'Size1920',

}
export interface MediaTypeMetaData {
  /** @nullable */
  height?: number | null;
  type: MediaBankFileInfoType;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  width?: number | null;
}

export enum LocationType {
  Vessel= 'Vessel',
  Site= 'Site',

}
export interface LocationRequest {
  address: string;
  charterer: string;
  description: string;
  group: string;
  identifier: string;
  latitude: string;
  locationType: LocationType;
  longitude: string;
  operator: string;
  owner: string;
  shipyard: string;
  vesselType: string;
}

export interface LocationMapResponse {
  id: number;
  latitude: string;
  longitude: string;
}

export type LocationId = number;

export interface LocationDetailsResponse {
  address: string;
  charterer: string;
  description: string;
  /** @nullable */
  group?: string | null;
  id: LocationId;
  identifier: string;
  latitude: string;
  locationType: LocationType;
  longitude: string;
  /** @nullable */
  marineTrafficLink?: string | null;
  operator: string;
  owner: string;
  shipyard: string;
  vesselType: string;
}

export enum LineType {
  Standard= 'Standard',
  Application= 'Application',
  Insert= 'Insert',
  AddOn= 'AddOn',
  MandatoryAddOn= 'MandatoryAddOn',
  Accessory= 'Accessory',
  CompanionProduct= 'CompanionProduct',

}
export interface LegalEntityResponse {
  legalEntities: string[];
}

export interface LayoutResponse {
  frontPageUrl: string;
  megaMenu: MegaMenuModel;
  staticLinks: StaticLinkModel[];
}

export enum IncoTerms {
  FCA= 'FCA',
  DAP= 'DAP',
  DDP= 'DDP',

}
export interface IncludedItemMetaData {
  productId: string;
  quantity: number;
}

export interface ImageSizeResponse {
  /** @nullable */
  height?: number | null;
  url: AbsoluteUrl;
  /** @nullable */
  width?: number | null;
}

export interface ImageResponse {
  /** @nullable */
  altText?: string | null;
  originalUrl?: AbsoluteUrl;
  size1280?: ImageSizeResponse;
  size180?: ImageSizeResponse;
  size1920?: ImageSizeResponse;
  size320?: ImageSizeResponse;
  size480?: ImageSizeResponse;
  size720?: ImageSizeResponse;
  size960?: ImageSizeResponse;
}

export interface ImageLookupResponseItem {
  /**
   * The optional cropping id that was looked up for the file.
   * @nullable
   */
  croppingId?: string | null;
  /** The file id that was looked up. */
  fileId: string;
  /**
   * The optional path that was looked up for the file if no id matched.
   * @nullable
   */
  filePath?: string | null;
  image: ImageResponse;
}

export interface ImageLookupResponse {
  /** The list files that matched the ids. */
  images: ImageLookupResponseItem[];
}

export interface ImageLookupRequestItem {
  /**
   * The optional cropping id to lookup for the file.
   * @nullable
   */
  croppingId?: string | null;
  /** The file id to lookup. */
  fileId: string;
  /**
   * The optional path to lookup for the file if no id matches.
   * @nullable
   */
  filePath?: string | null;
}

export interface ImageLookupRequest {
  /** The list of file ids to lookup. */
  images: ImageLookupRequestItem[];
}

export type HttpValidationProblemDetailsErrors = {[key: string]: string[]};

export interface HttpValidationProblemDetails {
  /** @nullable */
  detail?: string | null;
  errors: HttpValidationProblemDetailsErrors;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export enum GlobalListType {
  OilDieselFluid= 'OilDieselFluid',
  PowerSupply= 'PowerSupply',
  VesselType= 'VesselType',
  OilSystems= 'OilSystems',
  OilSystemBrands= 'OilSystemBrands',

}
export interface GlobalListResponse {
  attributeNameMappings: GlobalListAttributeMapping[];
  globalLists: GlobalList[];
}

export interface GlobalListItem {
  /** @nullable */
  note?: string | null;
  systemName: string;
  value: string;
}

export type GlobalListId = string;

export interface GlobalListAttributeMapping {
  attribute: AttributeSystemName;
  globalList: GlobalListId;
}

export interface GlobalList {
  id: GlobalListId;
  values: GlobalListItem[];
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface FilterUnitRegistrationUpdateRequest {
  /** @nullable */
  articleNumber?: string | null;
  insert?: FilterInsertRegistrationUpdateRequest;
  /** @nullable */
  insertType?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  numberOfInserts?: number | null;
  /** @nullable */
  orderNo?: string | null;
}

export interface FilterUnitRegistrationResponse {
  /** @nullable */
  articleNumber?: string | null;
  id: FilterUnitRegistrationId;
  insert?: FilterInsertRegistrationResponse;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  orderNo?: string | null;
  spareParts: SparePartRegistrationResponse[];
}

export interface FilterUnitRegistrationRequest {
  /** @nullable */
  articleNumber?: string | null;
  insert?: FilterInsertRegistrationRequest;
  /** @nullable */
  insertType?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  numberOfInserts?: number | null;
  /** @nullable */
  orderNo?: string | null;
}

export type FilterUnitRegistrationId = number;

export interface FilterUnitRegistration {
  /** @nullable */
  articleNumber?: string | null;
  id: FilterUnitRegistrationId;
  inserts: FilterInsertRegistration[];
  /** @nullable */
  insertType?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  numberOfInserts?: number | null;
  /** @nullable */
  orderNo?: string | null;
  spareParts: SparePartRegistration[];
}

export interface FilterModel {
  display: string;
  value: string;
}

export interface FilterKeyModel {
  displayName: string;
  groupKey: string;
  groupName: string;
  values: FilterModel[];
}

export interface FilterInsertRegistrationRequest {
  /** @nullable */
  articleNumber?: string | null;
  /** @nullable */
  batchNumber?: string | null;
  /** @nullable */
  installationDate?: string | null;
  /** @nullable */
  lastChangedDate?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  saleDate?: string | null;
}

export type FilterInsertRegistrationId = number;

export interface FilterInsertRegistrationUpdateRequest {
  /** @nullable */
  articleNumber?: string | null;
  /** @nullable */
  batchNumber?: string | null;
  id: FilterInsertRegistrationId;
  /** @nullable */
  installationDate?: string | null;
  /** @nullable */
  lastChangedDate?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  saleDate?: string | null;
}

export interface FilterInsertRegistrationResponse {
  /** @nullable */
  articleNumber?: string | null;
  /** @nullable */
  batchNumber?: string | null;
  id: FilterInsertRegistrationId;
  /** @nullable */
  installationDate?: string | null;
  /** @nullable */
  lastChangedDate?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  saleDate?: string | null;
}

export interface FilterInsertRegistration {
  /** @nullable */
  articleNumber?: string | null;
  /** @nullable */
  batchNumber?: string | null;
  filterUnitRegistrationId: FilterUnitRegistrationId;
  id: FilterInsertRegistrationId;
  /** @nullable */
  installationDate?: string | null;
  /** @nullable */
  lastChangedDate?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  saleDate?: string | null;
}

export enum ExternalLoginProvider {
  AzureAdHesehus= 'AzureAdHesehus',
  AzureAdCJC= 'AzureAdCJC',

}
export type EmailAddress = string;

export interface DetailsResponse {
  /** @nullable */
  customerReference?: string | null;
  date: string;
  expirationDate: string;
  internalContact: string;
  /** @nullable */
  legalEntity?: string | null;
  /** @nullable */
  opportunityId?: string | null;
  /** @nullable */
  opportunityName?: string | null;
  ourSalesperson: string;
  paymentTerms: string;
  quoteType: string;
  salesAndDeliveryTerms: string;
  yourContact: string;
}

export enum DeliveryMethod {
  Road= 'Road',
  Sea= 'Sea',
  Air= 'Air',

}
export type CustomerSegmentId = string;

export interface CustomerSegmentResponse {
  applications: CustomerApplicationResponse[];
  icon?: SimpleImageResponse;
  id: CustomerSegmentId;
  name: string;
}

export enum CustomerSearchSorting {
  Country= 'Country',
  Segment= 'Segment',
  AccountName= 'AccountName',

}
export interface CustomerSearchSimpleResponseItem {
  /** @nullable */
  readonly customerNumber?: string | null;
  id: AccountId;
  readonly name: string;
  /** @nullable */
  readonly owner?: string | null;
}

export interface CustomerSearchSimpleResponse {
  customers: CustomerSearchSimpleResponseItem[];
  totalCount: number;
}

export type CustomerSearchResponseFilters = {
  ApplicationBrand: FilterKeyModel;
  ApplicationFluidType: FilterKeyModel;
  ApplicationMaxAmbientTemperature: FilterKeyModel;
  ApplicationMaxOperationOilTemperature: FilterKeyModel;
  ApplicationMinAmbientTemperature: FilterKeyModel;
  ApplicationMinOperationOilTemperature: FilterKeyModel;
  ApplicationModel: FilterKeyModel;
  ApplicationNormalOperationOilTemperature: FilterKeyModel;
  ApplicationPowerSupply: FilterKeyModel;
  ApplicationSystemVolume: FilterKeyModel;
  ApplicationType: FilterKeyModel;
  ApplicationViscosity: FilterKeyModel;
  CustomerCity: FilterKeyModel;
  CustomerCountry: FilterKeyModel;
  CustomerGroup: FilterKeyModel;
  CustomerKeyAccountManager: FilterKeyModel;
  CustomerOwner: FilterKeyModel;
  CustomerSegment: FilterKeyModel;
  CustomerSubSegment: FilterKeyModel;
  CustomerType: FilterKeyModel;
  FilterInsertType: FilterKeyModel;
  FilterName: FilterKeyModel;
  FilterNumberOfInserts: FilterKeyModel;
  ItemNumber: FilterKeyModel;
};

export interface CustomerSearchResponse {
  accounts: AccountModel[];
  filters: CustomerSearchResponseFilters;
  totalCount: number;
}

export interface CustomerHierarchyResponse {
  accountName: string;
  /** @nullable */
  accountNo?: string | null;
  children: CustomerHierarchyResponse[];
  /** @nullable */
  customerGroup?: string | null;
  /** @nullable */
  customerSegment?: string | null;
  /** @nullable */
  customerSubSegment?: string | null;
  /** @nullable */
  customerType?: string | null;
  /** @nullable */
  groupCoName?: string | null;
  id: AccountId;
  /** @nullable */
  internalName?: string | null;
  /** @nullable */
  keyAccountManager?: string | null;
  /** @nullable */
  nameLine2?: string | null;
  /** @nullable */
  owner?: string | null;
}

export interface CustomerDetailsResponse {
  /** @nullable */
  customerNumber?: string | null;
  /** @nullable */
  externalIdentifier?: string | null;
  /** @nullable */
  group?: string | null;
  /** @nullable */
  groupCoName?: string | null;
  id: AccountId;
  /** @nullable */
  internalName?: string | null;
  /** @nullable */
  keyAccountManager?: string | null;
  name: string;
  /** @nullable */
  nameLine2?: string | null;
  /** @nullable */
  owner?: string | null;
  /** @nullable */
  segment?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  subSegment?: string | null;
  /** @nullable */
  thirdPartyResponsible?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  url?: string | null;
}

export interface CustomerApplicationSpecificationResponse {
  label: string;
  text: string;
}

export type CustomerApplicationId = string;

export interface CustomerApplicationResponse {
  id: CustomerApplicationId;
  name: string;
  specifications: CustomerApplicationSpecificationResponse[];
  subApplications: CustomerApplicationResponse[];
}

export enum CurrencyPosition {
  Left= 'Left',
  Right= 'Right',

}
export interface CurrencySettingsResponse {
  currencyName: string;
  currencyPosition: CurrencyPosition;
  currencySymbol: string;
}

export interface CreateOrderResponse {
  accountId: AccountId;
  orderId: OrderId;
}

export interface CreateOrderRequest {
  address: Address;
  customerReference: string;
  deliveryMethod: DeliveryMethod;
  desiredDeliveryDate: string;
  expirationDate: string;
  incoTerms: IncoTerms;
  legalEntity: string;
  overwriteExisting: boolean;
  quoteType: QuoteType;
  status: OrderStatus;
  stock: string;
  yourContact: string;
}

export interface ConfirmEmailSetPasswordRequest {
  code: string;
  confirmPassword: string;
  password: string;
  userId: string;
}

export interface ConfirmEmailRequest {
  code: string;
  userId: string;
}

export interface CmsSettingsResponse {
  cmsMegaMenu: string;
  footerContact: string;
  footerMenu: string;
  headerDrawerMenu: string;
  internalServerError: string;
  notFound: string;
  page: string;
  uspMenu: string;
}

export enum CmsModel {
  Page= 'Page',
  NotFound= 'NotFound',
  InternalServerError= 'InternalServerError',

}
export interface ChangePasswordRequest {
  confirmPassword: string;
  oldPassword: string;
  password: string;
}

export enum BrowserDeviceType {
  Desktop= 'Desktop',
  Mobile= 'Mobile',
  Tablet= 'Tablet',

}
export interface BreadCrumbModel {
  link?: Url;
  route?: ResourceLocation;
  text: string;
  to?: RelativeUrl;
}

export type BrandId = string;

export interface Brand {
  id: BrandId;
  name: string;
  /** @nullable */
  segment?: string | null;
}

export interface BrandListResponse {
  brands: Brand[];
}

export interface BasketResponse {
  applicationLines: PurchaseApplicationLineResponse[];
  createdFromOrder: boolean;
  currency: string;
  dutyCharges: number;
  freightTotal: number;
  insuranceAmount: number;
  lines: PurchaseLineResponse[];
  /** @nullable */
  name?: string | null;
  /**
   * If there was a notification as a result of a line update, this is the notification text.
   * @nullable
   */
  notificationStatus?: string | null;
  totalInclVat: number;
  totalOutlayShippingCharges: number;
  totalVat: number;
}

export type BasketLineId = number;

export type AttributeSystemName = string;

export type AttributeDescriptionsResponseDescriptions = {[key: string]: string};

export interface AttributeDescriptionsResponse {
  descriptions: AttributeDescriptionsResponseDescriptions;
}

export interface AssociatedProductReference {
  categoryId: string;
  productMasterId: string;
}

export enum Area {
  StaticPages= 'StaticPages',
  ProductCategory= 'ProductCategory',
  Product= 'Product',

}
export interface ApplicationRegistrationRequest {
  /** @nullable */
  additionalInformation?: string | null;
  applicationSystemName: string;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  fluidBrand?: string | null;
  /** @nullable */
  fluidType?: string | null;
  /** @nullable */
  maxAmbientTemperature?: number | null;
  /** @nullable */
  maxOperationTemperature?: number | null;
  /** @nullable */
  minAmbientTemperature?: number | null;
  /** @nullable */
  minOperationTemperature?: number | null;
  /** @nullable */
  model?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  normalOperationTemperature?: number | null;
  /** @nullable */
  oilSystem?: string | null;
  /** @nullable */
  oilSystemBrand?: string | null;
  /** @nullable */
  powerSupply?: string | null;
  segmentSystemName: string;
  /** @nullable */
  systemVolume?: number | null;
  /** @nullable */
  viscosity?: number | null;
}

export type ApplicationRegistrationId = number;

export interface ApplicationRegistrationWithoutFilterUnitResponse {
  /** @nullable */
  application?: string | null;
  applicationId?: ApplicationRegistrationId;
  /** @nullable */
  group?: string | null;
  /** @nullable */
  locationIdentifier?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oilSystem?: string | null;
  registrationCompositeId: RegistrationCompositeId;
}

export interface ApplicationRegistrationItemResponse {
  /** @nullable */
  application?: string | null;
  applicationId?: ApplicationRegistrationId;
  /** @nullable */
  filterInsertArticleNumber?: string | null;
  /** @nullable */
  filterInsertName?: string | null;
  /** @nullable */
  filterUnitArticleNumber?: string | null;
  filterUnitId?: FilterUnitRegistrationId;
  /** @nullable */
  filterUnitName?: string | null;
  hasLocation: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oilSystem?: string | null;
  registrationCompositeId: RegistrationCompositeId;
}

export interface ApplicationRegistrationGroupResponse {
  applicationRegistrations: ApplicationRegistrationItemResponse[];
  /** @nullable */
  group?: string | null;
  /** @nullable */
  identifier?: string | null;
}

export interface ApplicationRegistrationsResponse {
  groups: ApplicationRegistrationGroupResponse[];
  totalHits: number;
}

export interface ApplicationRegistrationCommentRequest {
  comment: string;
}

export type ApplicationRegistrationCommentId = number;

export interface ApplicationRegistrationCommentResponse {
  comment: string;
  id: ApplicationRegistrationCommentId;
}

export interface Address {
  addressOne: string;
  /** @nullable */
  addressTwo?: string | null;
  city: string;
  /** @nullable */
  country?: string | null;
  name: string;
  zipCode: string;
}

export interface AddBasketLineRequest {
  lineType: LineType;
  productId: string;
  quantity: number;
}

export interface AddApplicationLineRequest {
  additionalBasketLines: AddBasketLineRequest[];
  companionAdditionalLines: AddBasketLineRequest[];
  /** @nullable */
  companionVariantId?: string | null;
  productId: string;
  quantity: number;
}

export type AccountId = number;

export interface AccountModel {
  accountName: string;
  accountNo: string;
  country: string;
  customerGroup: string;
  customerSegment: string;
  customerSubSegment: string;
  customerType: string;
  groupCoName: string;
  id: AccountId;
  internalName: string;
  keyAccountManager: string;
  locations: LocationMapResponse[];
  nameLine2: string;
  owner: string;
}

export interface AccountLookupItemResponse {
  accountName: string;
  /** @nullable */
  accountNo?: string | null;
  id: AccountId;
  /** @nullable */
  internalName?: string | null;
  /** @nullable */
  nameLine2?: string | null;
  /** @nullable */
  owner?: string | null;
}

export interface AccountLookupResponse {
  accounts: AccountLookupItemResponse[];
  totalHits: number;
}

export type AbsoluteUrl = string;

